(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["landeros-novedades"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('landeros-gender-tabs')) {
    customElements.define('landeros-gender-tabs', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onTabClick);
        this.addEventListener('keydown', this.onTabKey);
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onTabClick);
        this.removeEventListener('keydown', this.onTabKey);
      }
      onTabClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab?.closest('landeros-gender-tabs') === this) this.selectTab(tab);
      };
      onTabKey = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || tab.closest('landeros-gender-tabs') !== this) return;
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        const index = tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        this.selectTab(tabs[next]);
        tabs[next].focus();
      };
      selectTab(tab) {
        for (const button of this.querySelectorAll('[role="tab"]')) {
          const selected = button === tab;
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
        }
        for (const panel of this.querySelectorAll('[role="tabpanel"]')) {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
